import React from 'react'

import { FilterComponentProps } from 'types/filter-page'
import NumberForm from '../number'

const YearForm = (props: FilterComponentProps) => {
  const { onPress, ...otherProps } = props
  return <NumberForm {...otherProps} onPress={onPress} yearOperators={true} />
}

export default YearForm
